import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AddressRecord } from '@navio/nsdk';
import { BookingAddress } from 'noddi-types';
import { NoddiButton, NoddiCard } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { useTireOfferStore } from '../../stores/tireOfferStore';
import { AddressLine } from '../Address/AddressLine';
import { TireOfferDeliveryCheckInfo } from './TireOfferDeliveryCheckInfo';

interface Props {
  slug: string;
  address: AddressRecord | BookingAddress;
  deliversToAddress: boolean | undefined;
}

/** The mounting address on the order review; Change reopens the address step with it picked. */
export const TireOfferAddressCard = ({ slug, address, deliversToAddress }: Props) => {
  const navigate = useNavigate();
  const setSelectedAddress = useTireOfferStore((state) => state.setSelectedAddress);

  return (
    <NoddiCard
      title={t`Address`}
      headerNode={
        <NoddiButton
          size='small'
          variant='outline'
          onClick={() => {
            setSelectedAddress(address);
            navigate(customerRoutes.tireOfferAddress.getPath({ slug }));
          }}
        >
          <Trans>Change</Trans>
        </NoddiButton>
      }
    >
      <div className='flex flex-col gap-3'>
        <AddressLine address={address} />
        {deliversToAddress === false && <TireOfferDeliveryCheckInfo deliversToAddress={false} />}
      </div>
    </NoddiCard>
  );
};
